import styled from '@emotion/styled';
import { ItemRow } from '@models/item';

import Badge from './Badge';

interface Props {
    item: ItemRow;
}

function Badges({ item }:Props) {
    const { badges } = item;
    return (
        <Container>
            {badges?.map((badge) => (
                <Badge key={badge}>{badge}</Badge>
            ))}
        </Container>
    );
}

const Container = styled.div`
    margin-top: 6px;
    flex-wrap: wrap;
    gap: 4px;
    display: flex;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    justify-content: center;
`;

export default Badges;
